import { render } from "./ClientAbonements.vue?vue&type=template&id=59a8c00f"
import script from "./ClientAbonements.vue?vue&type=script&lang=js"
export * from "./ClientAbonements.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__